import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as s, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBraces",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function _(e, t, i, u, f, a) {
  return d(), s("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--braces"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Braces",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    l("path", {
      d: "M2 9.5V7a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1 .5.5 0 0 0 .49-.402L2 5V2.5A1.5 1.5 0 0 1 3.5 1H4a.5.5 0 0 1 0 1h-.5a.5.5 0 0 0-.5.5V5c0 .37-.14.725-.386 1 .247.275.386.63.386 1v2.5c0 .274.226.5.5.5H4a.5.5 0 0 1 0 1h-.5C2.674 11 2 10.326 2 9.5Zm7 0V7c0-.384.146-.734.385-1A1.498 1.498 0 0 1 9 5V2.5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 1 0-1h.5A1.5 1.5 0 0 1 10 2.5V5a.5.5 0 0 0 .5.5.5.5 0 0 1 .1.99l-.2.02A.504.504 0 0 0 10 7v2.5A1.5 1.5 0 0 1 8.5 11H8a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .5-.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ o(c, [["render", _]]);
export {
  g as default
};
//# sourceMappingURL=braces.js.map
